<template>
  <nav class="pager">
    <div class="pager_btnBlock -prev" v-if="hasPrevPage">
      <button class="pager_btn" @click="clickPagerBtn(pageNum - 1)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="13.993"
          viewBox="0 0 8 13.993"
        >
          <path
            d="M2.412,7l5.295,5.291A1,1,0,1,1,6.29,13.7l-6-5.995A1,1,0,0,1,.262,6.328L6.286.292A1,1,0,1,1,7.7,1.7Z"
            fill="#58d1ca"
          />
        </svg>
      </button>
    </div>
    <ul class="pager_numberList">
      <li v-for="(page, i) in pagerArr" class="pager_num" :key="i">
        <span v-if="pageNum === page">{{ page }}</span>
        <button v-if="pageNum !== page" @click="clickPagerBtn(page)">
          {{ page }}
        </button>
      </li>
      <!--
        <li class="pager_num"><span>1</span></li>
        <li class="pager_dot">…</li>
        <li class="pager_num"><a href="">10</a></li>
      -->
    </ul>
    <div class="pager_btnBlock -next" v-if="hasNextPage">
      <button class="pager_btn" @click="clickPagerBtn(pageNum + 1)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="13.993"
          viewBox="0 0 8 13.993"
        >
          <path
            d="M5.588,7,.294,12.289A1,1,0,1,0,1.71,13.7l6-5.995a1,1,0,0,0,.029-1.379L1.714.292A1,1,0,1,0,.3,1.7Z"
            transform="translate(0 0)"
            fill="#58d1ca"
          />
        </svg>
      </button>
    </div>
  </nav>
</template>

<script lang="ts">
import { computed, SetupContext } from 'vue'

export default {
  name: 'Pager',

  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    },
    rowCnt: {
      type: Number,
      default: 15
    }
  },

  setup(props: any, context: SetupContext) {
    // 最大表示するページ数
    const maxShowLength = 5

    // 最大ページ数
    const totalPageLength = computed(() => {
      let len = Math.floor(props.totalCount / props.rowCnt)
      len += props.totalCount % props.rowCnt > 0 ? 1 : 0
      return len
    })

    const pagerArr = computed(() => {
      const arr = []
      let startPage = 0
      let endPage = 0

      if (totalPageLength.value <= maxShowLength) {
        startPage = 1
        endPage = totalPageLength.value
      } else {
        const pagerBeforeAfterLength = (maxShowLength - 1) / 2 // 現在地の前後に表示するナビの数
        startPage = props.pageNum - pagerBeforeAfterLength // 開始するナビの番号
        endPage = props.pageNum + pagerBeforeAfterLength // 終了するナビの番号

        // 開始ナビの番号が1以下になった場合は後ナビをその分増やす
        if (startPage < 1) {
          const diff = -(startPage - 1)
          endPage += diff
          startPage = 1
        }

        // 終了ナビの番号が最大以上になった場合は前ナビをその分増やす
        if (endPage > totalPageLength.value) {
          const diff = endPage - totalPageLength.value
          startPage -= diff
          endPage = totalPageLength.value
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        arr.push(i)
      }

      return arr
    })

    // 前のページに遷移するボタンを表示するか
    const hasPrevPage = computed(() => {
      return totalPageLength.value > 1 && props.pageNum > 1 ? true : false
    })

    // 次のページに遷移するボタンを表示するか
    const hasNextPage = computed(() => {
      return totalPageLength.value > 1 && props.pageNum < totalPageLength.value
        ? true
        : false
    })

    const clickPagerBtn = (num: number) => {
      context.emit('move-page', num)
    }

    return {
      hasPrevPage,
      hasNextPage,
      pagerArr,
      totalPageLength,
      clickPagerBtn
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 50px;

  @include mixins.media() {
    width: 343px;
    margin-right: auto;
    margin-left: auto;
  }

  &_btnBlock {
    width: 50px;
    position: absolute;

    &.-prev {
      left: 0;
    }

    &.-next {
      right: 0;
    }
  }

  &_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #e4e4e4;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
  }

  &_numberList {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &_num {
    font-size: 1.8rem;
    color: var.$color-main;

    button,
    span {
      display: block;
      padding: 10px;
    }

    span {
      color: var.$color-black;
    }
  }

  // &_dot {
  //   padding: 10px 8px;
  // }
}
</style>
